var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6c0-2.2-1.8-4-4-4S6 3.8 6 6h2c0-1.1.9-2 2-2s2 .9 2 2v2H5c-.6 0-1 .4-1 1v6c0 1.7 1.3 3 3 3h6c1.7 0 3-1.3 3-3V9c0-.6-.4-1-1-1h-1z"
  })));
};
export default SvgUnlock;